/* LaserGlow Cinematic Homepage Hero v7 (smooth scroll + frame blending + frame-range skip) */
(function () {
  "use strict";

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function smooth(a, b, v) { var t = clamp((v - a) / (b - a), 0, 1); return t * t * (3 - 2 * t); }

  function stepCurve(points, x) {
    if (x <= points[0][0]) return points[0][1];
    for (var i = 1; i < points.length; i++) {
      if (x <= points[i][0]) {
        var p0 = points[i - 1], p1 = points[i], t = (x - p0[0]) / (p1[0] - p0[0] || 1);
        t = t * t * (3 - 2 * t) * 0.35 + t * 0.65;
        return lerp(p0[1], p1[1], t);
      }
    }
    return points[points.length - 1][1];
  }

  function monotoneCurve(points) {
    var n = points.length, xs = [], ys = [], d = [], m = [], i;
    for (i = 0; i < n; i++) { xs.push(points[i][0]); ys.push(points[i][1]); }
    for (i = 0; i < n - 1; i++) d.push((ys[i + 1] - ys[i]) / ((xs[i + 1] - xs[i]) || 1e-6));
    m[0] = d[0]; m[n - 1] = d[n - 2];
    for (i = 1; i < n - 1; i++) m[i] = d[i - 1] * d[i] <= 0 ? 0 : (d[i - 1] + d[i]) / 2;
    for (i = 0; i < n - 1; i++) {
      if (d[i] === 0) { m[i] = 0; m[i + 1] = 0; continue; }
      var a = m[i] / d[i], b = m[i + 1] / d[i], s = a * a + b * b;
      if (s > 9) { var k = 3 / Math.sqrt(s); m[i] = k * a * d[i]; m[i + 1] = k * b * d[i]; }
    }
    return function (x) {
      if (x <= xs[0]) return ys[0];
      if (x >= xs[n - 1]) return ys[n - 1];
      var j = 1; while (x > xs[j]) j++;
      var h = xs[j] - xs[j - 1], t = (x - xs[j - 1]) / h, t2 = t * t, t3 = t2 * t;
      return (2 * t3 - 3 * t2 + 1) * ys[j - 1] + (t3 - 2 * t2 + t) * h * m[j - 1] + (-2 * t3 + 3 * t2) * ys[j] + (t3 - t2) * h * m[j];
    };
  }

  var DEFAULTS = {
    sets: {
      d: { base: "", count: 0, ext: "webp", pad: 4, w: 1920, h: 1080 },
      m: { base: "", count: 0, ext: "webp", pad: 4, w: 810, h: 1440 }
    },
    timeline: [[0, 0], [0.05, 0.004], [0.26, 0.24], [0.32, 0.262], [0.48, 0.5], [0.66, 0.738], [0.72, 0.762], [0.92, 0.996], [1, 1]],
    beats: { 1: [-1, -1, 0.035, 0.07], 2: [0.21, 0.25, 0.33, 0.36], 4: [0.89, 0.93, 2, 2] },
    tone: [[0, 1, 0], [0.52, 1, 0], [0.62, 0, 1], [1, 0, 1]],
    intro: true,
    smoothing: 0.2,
    panel: { dark: [5, 9, 20], light: [228, 227, 234] },
    subject: 0.63
  };

  function merge(base, extra) {
    var out = {}, k;
    for (k in base) out[k] = base[k];
    for (k in extra) {
      if (extra[k] && typeof extra[k] === "object" && !Array.isArray(extra[k]) && base[k] && typeof base[k] === "object") out[k] = merge(base[k], extra[k]);
      else if (extra[k] !== undefined && extra[k] !== null && extra[k] !== "") out[k] = extra[k];
    }
    return out;
  }

  function pad(n, len) { n = String(n); while (n.length < len) n = "0" + n; return n; }

  function mount(root) {
    if (root.__lgh) return root.__lgh;

    if (!document.getElementById("lgh-smooth-css")) {
      var st = document.createElement("style");
      st.id = "lgh-smooth-css";
      st.textContent = ".lgh__scrim{transition:none}.lgh__canvas{will-change:transform;transform-origin:50% 50%;backface-visibility:hidden}.lgh__stage{contain:layout paint}";
      document.head.appendChild(st);
    }

    var cfgEl = root.querySelector("[data-lgh-config]"), cfg = DEFAULTS;
    try { if (cfgEl) cfg = merge(DEFAULTS, JSON.parse(cfgEl.textContent || "{}")); } catch (err) { cfg = DEFAULTS; }

    ["d", "m"].forEach(function (k) {
      var s = cfg.sets[k];
      if (!s || !s.count || s.map) return;
      var sk = s.skip;
      if (sk && sk.length === 2 && sk[0] > 0 && sk[1] >= sk[0] && sk[1] < s.count - 1) {
        var map = [];
        for (var i = 0; i < s.count; i++) if (i < sk[0] || i > sk[1]) map.push(i);
        s.map = map; s.count = map.length;
      } else { s.timeline = null; }
    });

    var track = root.querySelector("[data-lgh-track]"),
        stage = root.querySelector("[data-lgh-stage]"),
        canvas = root.querySelector("[data-lgh-canvas]"),
        scrim = root.querySelector("[data-lgh-scrim]"),
        bar = root.querySelector("[data-lgh-bar]"),
        cue = root.querySelector("[data-lgh-cue]"),
        skip = root.querySelector("[data-lgh-skip]"),
        panel = root.querySelector("[data-lgh-panel]");

    if (skip) skip.addEventListener("click", function () {
      var r = track.getBoundingClientRect();
      window.scrollTo({ top: window.pageYOffset + r.bottom - 1, behavior: "smooth" });
    });

    var beats = {};
    [].forEach.call(root.querySelectorAll("[data-lgh-beat]"), function (el) { beats[el.getAttribute("data-lgh-beat")] = el; });

    var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var ctx = canvas && canvas.getContext ? canvas.getContext("2d", { alpha: false }) : null;

    function pickSet() {
      var mobile = window.innerWidth < 768 || window.innerWidth / window.innerHeight < 0.8;
      var ok = function (s) { return s && s.count > 0 && s.base; };
      var s = mobile && ok(cfg.sets.m) ? cfg.sets.m : cfg.sets.d;
      return ok(s) ? s : null;
    }

    var set = pickSet();
    if (!ctx || !set || reduced) {
      root.classList.add("is-static", "is-intro");
      root.style.setProperty("--lgh-lift", Math.max(0, Math.round(stage.getBoundingClientRect().top + window.pageYOffset)) + "px");
      return (root.__lgh = { static: true });
    }

    function frameAt(p) {
      var s = set;
      if (!s.__curve) s.__curve = monotoneCurve(s.timeline && s.timeline.length ? s.timeline : cfg.timeline);
      return s.__curve(p);
    }

    var lightScrim = document.createElement("div");
    lightScrim.className = "lgh__scrim lgh__scrim--light";
    lightScrim.setAttribute("aria-hidden", "true");
    scrim.parentNode.insertBefore(lightScrim, scrim.nextSibling);

    var black = document.createElement("div");
    black.className = "lgh__black";
    black.setAttribute("aria-hidden", "true");
    canvas.parentNode.insertBefore(black, canvas.nextSibling);

    function write(el, key, val, fn) {
      if (!el) return;
      var c = el.__lghc || (el.__lghc = {});
      if (c[key] === val) return;
      c[key] = val;
      fn(val);
    }
    function css(el, prop, val) { write(el, "s:" + prop, val, function (v) { el.style[prop] = v; }); }
    function cssVar(el, name, val) { write(el, "v:" + name, val, function (v) { el.style.setProperty(name, v); }); }
    function cls(el, name, on) { write(el, "c:" + name, on, function (v) { el.classList.toggle(name, v); }); }
    function attr(el, name, val) { write(el, "a:" + name, val, function (v) { el.setAttribute(name, v); }); }

    var imgs = [], ready = [], setKey = null, queue = [], active = 0, MAX = 6;
    var conn = navigator.connection || {}, lite = !!(conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ""));
    var pageLoaded = document.readyState === "complete", wave2 = [], wave3 = [], engaged = false, expected = 0;

    function url(s, i) { return s.base + pad(s.map ? s.map[i] : i, s.pad || 4) + "." + (s.ext || "webp") + (cfg.ver ? "?v=" + cfg.ver : ""); }

    function loadOrder(count) {
      var seen = {}, out = [];
      [16, 8, 4, 2, 1].forEach(function (step) {
        for (var i = 0; i < count; i += step) if (!seen[i]) { seen[i] = 1; out.push(i); }
      });
      if (!seen[count - 1]) out.push(count - 1);
      return out;
    }

    function pump() {
      while (active < MAX && queue.length) {
        (function (idx) {
          if (ready[idx] || imgs[idx]) return;
          active++;
          var im = new Image();
          im.decoding = "async";
          imgs[idx] = im;
          var done = function (ok) {
            active--;
            if (ok) { ready[idx] = true; dirty = true; schedule(); }
            pump();
          };
          im.onload = function () {
            done(true);
            if (im.decode) im.decode().then(null, function () {});
          };
          im.onerror = function () { imgs[idx] = null; done(false); };
          im.src = url(set, idx);
        })(queue.shift());
      }
    }

    function initSet() {
      var key = set.base + "|" + set.count;
      if (key === setKey) return;
      setKey = key;
      imgs = new Array(set.count);
      ready = new Array(set.count);
      var order = loadOrder(set.count).filter(function (i) { return !lite || i % 2 === 0 || i === set.count - 1; });
      expected = order.length;
      queue = order.filter(function (i) { return i < 4; });
      wave2 = order.filter(function (i) { return i >= 4 && (i < 12 || i % 16 === 0 || i === set.count - 1); });
      wave3 = order.filter(function (i) { return i >= 12 && i % 16 !== 0 && i !== set.count - 1; });
      if (pageLoaded) { queue = queue.concat(wave2); wave2 = []; }
      if (engaged || pageLoaded) { queue = queue.concat(wave3); wave3 = []; }
      pump();
    }

    function flush(list) { if (list.length) { queue = queue.concat(list); pump(); } return []; }

    if (!pageLoaded) window.addEventListener("load", function () {
      pageLoaded = true;
      setTimeout(function () { wave2 = flush(wave2); }, 150);
      setTimeout(function () { wave3 = flush(wave3); }, 900);
    });

    var ENGAGE = ["wheel", "touchstart", "keydown", "pointerdown", "scroll"];
    function engage() {
      if (engaged) return;
      engaged = true;
      wave2 = flush(wave2);
      wave3 = flush(wave3);
      ENGAGE.forEach(function (t) { window.removeEventListener(t, engage, { passive: true }); });
    }
    ENGAGE.forEach(function (t) { window.addEventListener(t, engage, { passive: true }); });

    function prioritize(idx, dir) {
      var want = [];
      for (var k = 0; k < 10; k++) {
        var j = idx + (dir >= 0 ? k : -k);
        if (j >= 0 && j < set.count && !ready[j] && !imgs[j]) want.push(j);
      }
      if (!want.length) return;
      queue = want.concat(queue.filter(function (q) { return want.indexOf(q) < 0; }));
      pump();
    }

    function nearestReady(idx, dir) {
      if (ready[idx]) return idx;
      for (var k = 1; k < set.count; k++) {
        var behind = idx - k * (dir >= 0 ? 1 : -1), ahead = idx + k * (dir >= 0 ? 1 : -1);
        if (behind >= 0 && behind < set.count && ready[behind]) return behind;
        if (ahead >= 0 && ahead < set.count && ready[ahead]) return ahead;
      }
      return -1;
    }

    var W = 0, H = 0, DPR = 1, split = false, cssW = 0, cssH = 0;

    function resize() {
      var s = pickSet();
      if (s && s !== set) { set = s; initSet(); }
      var r = stage.getBoundingClientRect();
      if (Math.abs(r.width - cssW) < 1 && Math.abs(r.height - cssH) < 1 && W) return;
      cssW = r.width; cssH = r.height;
      var need = Math.max((set.w || 1920) / Math.max(1, cssW), (set.h || 1080) / Math.max(1, cssH));
      DPR = clamp(Math.min(window.devicePixelRatio || 1, need), 1, 2);
      W = Math.max(1, Math.round(cssW * DPR));
      H = Math.max(1, Math.round(cssH * DPR));
      if (canvas.width !== W || canvas.height !== H) { canvas.width = W; canvas.height = H; }
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "high";
      split = set === cfg.sets.m && !!panel;
      cls(root, "is-split", split);
      lastFrame = -1;
      dirty = true;
    }

    function draw(img, shift) {
      var iw = img.naturalWidth, ih = img.naturalHeight;
      if (!iw || !ih) return;
      var sc = Math.max(W / iw, H / ih), dw = iw * sc, dh = ih * sc;
      ctx.drawImage(img, (W - dw) * 0.5, (H - dh) * 0.5 - (shift || 0) * DPR, dw, dh);
    }

    function subjectShift(img, panelTop) {
      var iw = img && img.naturalWidth, ih = img && img.naturalHeight;
      if (!iw || !ih) return 0;
      var vw = W / DPR, vh = H / DPR, dh = ih * Math.max(vw / iw, vh / ih);
      var y = (vh - dh) * 0.5 + cfg.subject * dh;
      return clamp(y - (panelTop + 40), 0, vh * 0.16);
    }

    var target = 0, current = 0, dirty = true, lastFrame = -1, lastMix = -1, lastShift = -1, lastFill = "", panelTop = 0;
    var started = performance.now(), lastTime = 0, pending = false, visible = true, lastDir = 1;

    function beatAlpha(b, p) {
      var fadeIn = b[0] < 0 ? 1 : smooth(b[0], b[1], p);
      var fadeOut = 1 - smooth(b[2], b[3], p);
      return Math.min(fadeIn, fadeOut);
    }
    function mix(a, b, t) {
      return Math.round(lerp(a[0], b[0], t)) + "," + Math.round(lerp(a[1], b[1], t)) + "," + Math.round(lerp(a[2], b[2], t));
    }

    function render(now, trackTop, trackH, stageTop) {
      var p = current, darkMax = 0, lightMax = 0, best = 0, bestEl = null, alphas = {}, key;

      for (key in beats) {
        if (!cfg.beats[key]) { css(beats[key], "display", "none"); continue; }
        var a = beatAlpha(cfg.beats[key], p);
        if (key === "1" && !root.classList.contains("is-intro")) a = 1;
        alphas[key] = a;
        if (beats[key].classList.contains("is-light")) lightMax = Math.max(lightMax, a); else darkMax = Math.max(darkMax, a);
        if (a > best) { best = a; bestEl = beats[key]; }
      }

      if (split && bestEl) panelTop = bestEl.offsetTop - 96;

      for (key in alphas) {
        var el = beats[key], al = alphas[key], b = cfg.beats[key];
        css(el, "opacity", al.toFixed(3));
        cssVar(el, "--lgh-dy", ((1 - al) * (p < (b[1] + b[2]) / 2 ? 24 : -24)).toFixed(1) + "px");
        cls(el, "is-on", al > 0.5);
        attr(el, "aria-hidden", al > 0.05 ? "false" : "true");
      }

      var tone = stepCurve(cfg.tone.map(function (t) { return [t[0], t[2]]; }), p);
      css(scrim, "opacity", darkMax.toFixed(3));
      css(lightScrim, "opacity", lightMax.toFixed(3));

      var fill = "0,0,0", shift = 0;
      var exact = clamp(frameAt(p), 0, 1) * (set.count - 1);
      var idx = Math.min(set.count - 1, Math.floor(exact)), frac = idx >= set.count - 1 ? 0 : exact - idx;
      if (!ready[idx]) prioritize(idx, lastDir);
      if (frac > 0 && !ready[idx + 1]) prioritize(idx + 1, lastDir);
      var show = nearestReady(idx, lastDir);
      var next = -1, mixq = 0;
      if (show === idx && frac > 0.04 && ready[idx + 1]) {
        mixq = Math.round(frac * 12) / 12;
        if (mixq >= 1) { show = idx + 1; mixq = 0; } else if (mixq > 0) next = idx + 1;
      }

      if (split) {
        fill = mix(cfg.panel.dark, cfg.panel.light, tone);
        css(panel, "top", Math.round(panelTop) + "px");
        css(panel, "opacity", best.toFixed(3));
        cssVar(root, "--lgh-pc", fill);
        if (show >= 0) shift = Math.round(subjectShift(imgs[show], panelTop) * best);
      }

      if (show >= 0 && (show !== lastFrame || mixq !== lastMix || shift !== lastShift || fill !== lastFill || dirty)) {
        lastFrame = show; lastMix = mixq; lastShift = shift; lastFill = fill;
        ctx.globalAlpha = 1;
        ctx.fillStyle = "rgb(" + fill + ")";
        ctx.fillRect(0, 0, W, H);
        draw(imgs[show], shift);
        if (next >= 0) { ctx.globalAlpha = mixq; draw(imgs[next], shift); ctx.globalAlpha = 1; }
        if (!root.classList.contains("is-live")) root.classList.add("is-live");
      }

      var breathe = 1 - smooth(0, 0.06, p);
      var zoom = breathe > 0 ? 1 + breathe * (0.012 + 0.008 * Math.sin((now - started) / 2600)) : 1;
      css(canvas, "transform", zoom === 1 ? "none" : "scale(" + zoom.toFixed(4) + ")");

      if (bar) css(bar, "transform", "scaleY(" + p.toFixed(4) + ")");
      if (cue) css(cue, "visibility", p > 0.03 ? "hidden" : "");
      cssVar(root, "--lgh-lift", Math.max(0, Math.round(stageTop)) + "px");
      if (skip) {
        cls(skip, "is-light", tone > 0.5);
        cls(skip, "is-gone", p < 0.045 || p > 0.9);
      }
    }

    function tick(now) {
      pending = false;
      if (!visible) return;
      var tr = track.getBoundingClientRect();
      var stageTop = stage.getBoundingClientRect().top;
      var span = tr.height - window.innerHeight;
      var prevTarget = target;
      target = span > 0 ? clamp(-tr.top / span, 0, 1) : 0;
      if (target !== prevTarget) lastDir = target > prevTarget ? 1 : -1;

      var dt = lastTime ? Math.min(64, now - lastTime) : 16.67;
      lastTime = now;
      var diff = target - current;
      var k = 1 - Math.pow(1 - cfg.smoothing, dt / 16.67);
      current = Math.abs(diff) < 0.0003 ? target : current + diff * k;

      render(now, tr.top, tr.height, stageTop);
      dirty = false;

      if (Math.abs(target - current) > 0.0002 || current < 0.06) schedule();
      else lastTime = 0;
    }

    function schedule() { if (!pending) { pending = true; requestAnimationFrame(tick); } }

    function intro() {
      if (!cfg.intro) { root.classList.add("is-intro", "is-lit"); return; }
      setTimeout(function () { root.classList.add("is-flash"); }, 250);
      setTimeout(function () { root.classList.add("is-lit"); }, 380);
      setTimeout(function () { root.classList.add("is-intro"); }, 820);
    }

    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) { lastTime = 0; schedule(); }
      }, { rootMargin: "200px" }).observe(track);
    }

    window.addEventListener("scroll", schedule, { passive: true });
    var resizeTimer = 0;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { resize(); schedule(); }, 120);
    });
    document.addEventListener("visibilitychange", function () { if (!document.hidden) { lastTime = 0; schedule(); } });

    resize();
    initSet();
    var tr0 = track.getBoundingClientRect(), span0 = tr0.height - window.innerHeight;
    current = target = span0 > 0 ? clamp(-tr0.top / span0, 0, 1) : 0;
    if (current > 0.03) { cfg.intro = false; engage(); }
    intro();
    schedule();

    var api = {
      seek: function (v) { current = target = clamp(v, 0, 1); render(performance.now(), 0, 0, stage.getBoundingClientRect().top); },
      state: function () {
        return { p: current, set: set === cfg.sets.m ? "m" : "d", split: split, shift: lastShift, panelTop: panelTop,
          loaded: ready.filter(Boolean).length, total: set.count, expected: expected, lite: lite, engaged: engaged, dpr: DPR, canvas: W + "x" + H };
      },
      ready: function () { return ready.filter(Boolean).length >= expected; }
    };
    root.__lgh = api;
    return api;
  }

  function boot(scope) { [].forEach.call((scope || document).querySelectorAll("[data-lg-home-hero]"), mount); }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { boot(); });
  else boot();
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
  window.LaserGlowHomeHero = { mount: mount, boot: boot };
})();
